import { initSpa } from '../../src/libs/helpers/init-spa'
import router from '../../src/routers/router.club'
import { SpaName } from '../../src/vars/SpaAttr'

initSpa(router, SpaName.LECLUB)
